import Navbar from './components/Navbar';
import { useTheme } from './context/ThemeContext';
import './App.css';
import UpArrow from './assets/icons/light/ArrowRise.svg';
import DownArrow from './assets/icons/light/ArrowFall.svg';
import DarkUpArrow from './assets/icons/dark/ArrowRise.svg';
import DarkDownArrow from './assets/icons/dark/ArrowFall.svg';

import BarChartCard from './components/BarChartCard';
import RevenueChart from './components/RevenueChart';
import Location from './components/Location';
import TopProducts from './components/TopProducts';
import TotalSales from './components/TotalSales';
import { useNavigate } from 'react-router-dom';

function App() {
  const { theme } = useTheme();

  const navigate = useNavigate();
  const navigateToOrders = () => {
    navigate('/orders');
  };

  return (
    <div
      className={`App min-h-screen transition-all duration-300 ${theme === '#1c1c1c' ? 'bg-[#1c1c1c] text-white' : 'bg-white text-black'
        }`}
    >
      <Navbar />
      <div className='mt-[28px] ml-[240px]'>
        <p className='my-bold'>eCommerce</p>
        <div className='flex mt-[15px] gap-8'>
          <div className="grid grid-cols-2 gap-8 w-[432px] h-[252px] cursor-default">
            <div className='bg-[#e3f5ff] rounded-xl w-[202px] h-[112px] text-black hover:scale-105 transition-transform'>
              <div className='p-6 gap-4'>
                <p className='my-bold text-sm hover:bg-[#ebedef] rounded-lg'>Customers</p>
                <div className='flex justify-between items-center mt-2'>
                  <p className='my-bold text-2xl'>3,781</p>
                  <div className='flex'>
                    <p className='text-xs'>+11.01%</p>
                    <img src={UpArrow} alt="up arrow" className='w-[16px] h-[16px] ml-1' />
                  </div>
                </div>
              </div>
            </div>
            <div className={` ${theme === '#1c1c1c' ? 'bg-[#272727]' : 'bg-[#f7f9fb]'} rounded-xl w-[202px] h-[112px] hover:scale-105 transition-transform`}>
              <div className='p-6 gap-4'>
                <p className={`my-bold text-sm hover:${theme === '#1c1c1c' ? 'bg-[#3e3e3e]' : 'bg-[#ebedef]'} rounded-lg`} onClick={navigateToOrders}>Orders</p>
                <div className='flex justify-between items-center mt-2'>
                  <p className='my-bold text-2xl'>1,219</p>
                  <div className='flex'>
                    <p className='text-xs'>-0.03%</p>
                    <img src={theme === '#1c1c1c' ? DarkDownArrow : DownArrow} alt="down arrow" className='w-[16px] h-[16px] ml-1' />
                  </div>
                </div>
              </div>
            </div>
            <div className={` ${theme === '#1c1c1c' ? 'bg-[#272727]' : 'bg-[#f7f9fb]'} rounded-xl w-[202px] h-[112px] hover:scale-105 transition-transform`}>
              <div className='p-6 gap-4'>
                <p className={`my-bold text-sm hover:${theme === '#1c1c1c' ? 'bg-[#3e3e3e]' : 'bg-[#ebedef]'} rounded-lg`}>Revenue</p>
                <div className='flex justify-between items-center mt-2'>
                  <p className='my-bold text-2xl'>$695</p>
                  <div className='flex'>
                    <p className='text-xs'>+15.03%</p>
                    <img src={theme === '#1c1c1c' ? DarkUpArrow : UpArrow} alt="up arrow" className='w-[16px] h-[16px] ml-1' />
                  </div>
                </div>
              </div>
            </div>
            <div className='bg-[#e3f5ff] rounded-xl w-[202px] h-[112px] text-black hover:scale-105 transition-transform'>
              <div className='p-6 gap-4'>
                <p className='my-bold text-sm hover:bg-[#ebedef] rounded-lg'>Growth</p>
                <div className='flex justify-between items-center mt-2'>
                  <p className='my-bold text-2xl'>30.1%</p>
                  <div className='flex'>
                    <p className='text-xs'>+6.08%</p>
                    <img src={UpArrow} alt="up arrow" className='w-[16px] h-[16px] ml-1' />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`w-[432px] h-[252px] ${theme === '#1c1c1c' ? 'bg-[#282828]' : 'bg-[#f7f9fb]'} rounded-xl hover:scale-105 transition-transform`}>
            <p className='p-4 text-sm my-bold'>Projects Vs Actuals</p>
            <BarChartCard />
          </div>
        </div>

        <div className='flex mt-[28px] gap-8'>
          <div className={`w-[662px] h-[318px] ${theme === '#1c1c1c' ? 'bg-[#282828]' : 'bg-[#f7f9fb]'} rounded-xl hover:scale-105 transition-transform`}>
            <div className="flex items-center justify-start p-4 mb-4 gap-4">
              <h2
                className="text-sm my-bold ml-1"
              >
                Revenue
              </h2>
              <p className='text-[#cbcdce]'>|</p>

              <div className="flex gap-8 text-sm">
                <div className="flex items-center gap-1">
                  <span
                    className="inline-block w-2 h-2 rounded-full"
                    style={{ backgroundColor: "#000" }}
                  ></span>
                  <span>
                    Current Week <span className="my-bold">$58,211</span>
                  </span>
                </div>
                <div className="flex items-center gap-1">
                  <span
                    className="inline-block w-2 h-2 rounded-full"
                    style={{ backgroundColor: "#93C5FD" }}
                  ></span>
                  <span>
                    Previous Week <span className="my-bold">$68,768</span>
                  </span>
                </div>
              </div>
            </div>
            <RevenueChart />
          </div>
          <Location />
        </div>

        <div className='flex mt-[28px] gap-8'>
          <TopProducts />
          <TotalSales />
        </div>
      </div>
    </div>
  );
}

export default App;
